import { MatSnackBar } from '@angular/material/snack-bar';
import { GlobalService, UserService } from '@app/services';
import { Component, OnInit } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { firstValueFrom } from 'rxjs';

registerLocaleData(localeEsMx, 'es-MX');

@Component({
    selector: 'app-protected-actions',
    templateUrl: './protected-actions.component.html',
    styleUrls: ['./protected-actions.component.scss'],
    standalone: false
})
export class ProtectedActionsComponent implements OnInit {

  protectedActionsRequests: any = [];
  permissionAccess: boolean = false;
  noEdition: boolean = false;

  // Custom Pagination
  searchActionsTerm: any;
  filteredActions: any = [];
  actionsPerPage = 5;
  actionsCurrentPage = 0;
  totalActions = 0;

  // See request details
  actionDetails: any = null;

  constructor(
    private userService: UserService,
    private globalService: GlobalService,
    private matSnackBar: MatSnackBar
  ) { }

  async ngOnInit() {
    await this.loadProtectedActions();

    this.permissionAccess = this.globalService.verifyPermissionAccess('admin_protected_actions_mod');

  }

  async loadProtectedActions() {
    let actionRequests = await firstValueFrom(this.userService.getProtectedActionsRequests())

    if (actionRequests.error) {
      return;
    }

    this.matSnackBar.open(
      'Se cargaron las acciones con exito.',
      null,
      {
        horizontalPosition: 'end',
        duration: 1500
      }
    )

    this.protectedActionsRequests = actionRequests.data;
  }


  async processRequest(processType: string, request: any) {

    let dataToProcessRequest = null;
    let processName = null;

    switch (processType) {
      case "approve":

        dataToProcessRequest = {
          request_id: request.request_id,
          process_type: 'approve'
        }

        processName = "aprobo";

        break;
      case "reject":

        dataToProcessRequest = {
          request_id: request.request_id,
          process_type: 'reject'
        }

        processName = "rechazo";

        break;
    }

    let processedRequest = await firstValueFrom(this.userService.processProtectedActionRequest(dataToProcessRequest))

    if (processedRequest.error) {
      console.log("processedRequest", processedRequest);
      return;
    }

    alert(`Se '${processName}' con exitó la solicitud.`);


    this.loadProtectedActions();

  }

  paginatedDataByTable(table: string) {
    switch (table) {
      case "actions":

        const startActionsIndex = this.actionsCurrentPage * this.actionsPerPage;
        const endActionsIndex = startActionsIndex + this.actionsPerPage;

        if (this.searchActionsTerm) {
          return this.filteredActions.slice(startActionsIndex, endActionsIndex);
        } else {
          return this.protectedActionsRequests.slice(startActionsIndex, endActionsIndex);
        }
    }
  }

  searchTermByTable(table: string) {
    switch (table) {
      case "actions":
        if (!this.searchActionsTerm) {
          this.filteredActions = [];
          this.actionsCurrentPage = 0;
          this.totalActions = this.protectedActionsRequests.length;
        } else {
          this.filteredActions = this.protectedActionsRequests.filter(action =>
            action.user.name.toLowerCase().includes(this.searchActionsTerm.toLowerCase()) ||
            action.user.lastname.toLowerCase().includes(this.searchActionsTerm.toLowerCase())
          );
          this.actionsCurrentPage = 0;
          this.totalActions = this.filteredActions.length;
        }
        break;
    }
  }

  pageChanged(event: any, table: string) {
    switch (table) {
      case "actions":
        this.actionsCurrentPage = event.pageIndex;
        this.actionsPerPage = event.pageSize;
        break;
    }
  }



  // Design functions
  getBadgeByStatus(statusData) {

    let statusCode = null

    if (statusData) {
      statusCode = statusData.code;
    }

    let className = null;
    switch (statusCode) {
      case "PENDING":
        className = "badge-primary";
        break;
      case "REJECTED":
        className = "badge-warning";
        break;
      case "EXPIRED":
        className = "badge-warning";
        break;
      case "COMPLETED":
        className = "badge-success";
        break;
      case "FAILED":
        className = "badge-danger";
        break;
      default:
        className = "badge-secondary";
        break;
    }

    return className

  }

}
